import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { GlobalComponent } from "../../global-component";
import { AuthUserModel } from 'src/app/account/models/auth.model';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    // httpDirect bypasses all interceptors — used exclusively for auth endpoints
    private httpDirect: HttpClient;

    constructor(private http: HttpClient, handler: HttpBackend) {
        this.httpDirect = new HttpClient(handler);
    }

    login(email: string, password: string) {
        return this.httpDirect.post(`${GlobalComponent.API_URL}auth/login`, {
            email,
            password
        }, httpOptions).pipe(
            map((response: any) => response),
            catchError(() => throwError(() => new Error('Login failed')))
        );
    }

    refreshToken(): Observable<string> {
        const currentUser = this.getLoggedUser();
        return this.httpDirect.post<any>(`${GlobalComponent.API_URL}auth/refresh`, {}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${currentUser?.token ?? ''}`
            })
        }).pipe(
            map((response: any) => {
                if (response?.token) {
                    const updatedUser: AuthUserModel = { ...currentUser!, token: response.token };
                    this.saveUser(updatedUser);
                    return response.token as string;
                }
                throw new Error('No token in refresh response');
            })
        );
    }

    changePassword(userId: string, password: string) {
        return this.http.post(`${GlobalComponent.API_URL}usuario-sistema/change-password`, { userId, password }, httpOptions);
    }

    saveUser(user: AuthUserModel): void {
        localStorage.setItem('currentUser', JSON.stringify(user));
    }

    getLoggedUser(): AuthUserModel | null {
        const raw = localStorage.getItem('currentUser');
        if (!raw) return null;
        return JSON.parse(raw) as AuthUserModel;
    }

    logout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('token');
        localStorage.removeItem('menuData');
        localStorage.removeItem('layoutTheme');
    }

    loggedEmployeeHasPermission(permissionCode: string): boolean {
        return this.getLoggedUser()?.permissions.find(x => x === permissionCode) !== undefined;
    }

    canViewOption(permiso: string): boolean {
        return this.getLoggedUser()?.permissions.find(x => x === permiso) !== undefined;
    }
}
